import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot, Icons, VALUES, firstNameOf } from "./shared";

// Cream editorial layout with a sweeping photo cut and a forest values strip.
export default function Editorial({ data, headshot }) {
  const first = firstNameOf(data.name) || "Name";
  return (
    <div className="wp-canvas wp-t-editorial">
      <div className="wp-t-editorial__photo-wrap">
        <Headshot headshot={headshot} className="wp-t-editorial__photo" />
      </div>

      <div className="wp-t-editorial__ornament" />

      <header className="wp-t-editorial__top">
        <LandmarkLogo width={250} className="wp-t-editorial__logo" />
        {data.team && <div className="wp-t-editorial__team">{data.team}</div>}
      </header>

      <div className="wp-t-editorial__copy">
        <h1>
          <span className="wp-t-editorial__welcome">Welcome,</span>
          <span className="wp-t-editorial__name">{first}!</span>
        </h1>
        {data.tagline && <p className="wp-t-editorial__tagline">{data.tagline}</p>}
        {data.role && <p className="wp-t-editorial__role">{data.role}</p>}
        <span className="wp-t-editorial__dash" />
      </div>

      {data.note && <div className="wp-t-editorial__note">{data.note}</div>}

      <footer className="wp-t-editorial__footer">
        <ul>
          {VALUES.map((v) => {
            const Icon = Icons[v.icon];
            return (
              <li key={v.icon}>
                <Icon width={44} height={44} />
                <span>
                  {v.label[0]}
                  <br />
                  {v.label[1]}
                </span>
              </li>
            );
          })}
        </ul>
        <div className="wp-t-editorial__strap">
          <i />
          <span>Success at every stage</span>
          <i />
        </div>
      </footer>
    </div>
  );
}
